// ── ConeBarn v10 JS — streamlined ──

// ── Hero bg parallax + load
const heroBg = document.getElementById('heroBg');
setTimeout(() => heroBg && heroBg.classList.add('loaded'), 100);

// ── Scroll reveal
const sio = new IntersectionObserver((e) => {
  e.forEach(x => { if (x.isIntersecting) { x.target.classList.add('in'); sio.unobserve(x.target); } });
}, { threshold: 0.1 });
document.querySelectorAll('.fade, .fade-l, .fade-r').forEach(el => sio.observe(el));

// ── Combined scroll handler (throttled)
const nav = document.getElementById('mainNav');
const floatCta = document.getElementById('floatCta');
const progressBar = document.getElementById('progressBar');
const backTop = document.getElementById('backTop');
const sections = ['hero','value','quality','size','shop','faq'];
const dots = document.querySelectorAll('.sec-dot');

let ticking = false;
window.addEventListener('scroll', () => {
  if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
}, { passive: true });

function onScroll() {
  const y = window.scrollY;
  const max = document.body.scrollHeight - window.innerHeight;
  const pct = max > 0 ? (y / max) * 100 : 0;

  // Nav
  if (nav) nav.classList.toggle('solid', y > 80);
  // Floating CTA
  if (floatCta) floatCta.classList.toggle('show', y > 600);
  // Progress bar
  if (progressBar) {
    progressBar.style.width = pct + '%';
    progressBar.classList.toggle('show', y > 100);
  }
  // Back to top
  if (backTop) backTop.classList.toggle('show', y > 600);
  // Parallax hero
  if (heroBg && y < window.innerHeight) {
    heroBg.style.transform = 'translateY(' + (y * 0.38) + 'px)';
  }
  // Section dots
  let activeSec = sections[0];
  sections.forEach(id => {
    const el = document.getElementById(id);
    if (el && el.getBoundingClientRect().top <= 120) activeSec = id;
  });
  dots.forEach((dot, i) => dot.classList.toggle('active', sections[i] === activeSec));
  // Dark/light dot color
  const darkSections = ['quality'];
  const onDark = darkSections.some(cls => {
    const el = document.querySelector('.' + cls) || document.getElementById(cls);
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.top <= 60 && r.bottom > 60;
  });
  document.body.classList.toggle('on-dark', onDark);

  ticking = false;
}

// Section dot click
dots.forEach((dot, i) => {
  dot.addEventListener('click', () => {
    const el = document.getElementById(sections[i]);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

// ── Annotations
const annoIO = new IntersectionObserver((e) => {
  e.forEach(x => {
    if (x.isIntersecting) {
      document.querySelectorAll('.anno').forEach((a, i) => setTimeout(() => a.classList.add('show'), i * 280));
      annoIO.unobserve(x.target);
    }
  });
}, { threshold: 0.3 });
const annoSec = document.querySelector('.annotated-section');
if (annoSec) annoIO.observe(annoSec);

// ── Glue bars
const glueIO = new IntersectionObserver((e) => {
  e.forEach(x => {
    if (x.isIntersecting) {
      x.target.querySelectorAll('.glue-bar-fill[data-width]').forEach(b => {
        setTimeout(() => b.style.width = b.dataset.width + '%', 250);
      });
      glueIO.unobserve(x.target);
    }
  });
}, { threshold: 0.4 });
document.querySelectorAll('.stats-section').forEach(el => glueIO.observe(el));

// ── Dot grid
const grid = document.getElementById('dotGrid');
if (grid) {
  for (let i = 0; i < 100; i++) {
    const d = document.createElement('div');
    d.className = 'dot-cell' + (i >= 95 ? ' bad' : '');
    grid.appendChild(d);
  }
}

// ── FAQ
function openFaq(qEl) {
  const item = qEl.parentElement;
  const aEl = item.querySelector('.faq-a');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => {
    i.classList.remove('open');
    i.querySelector('.faq-a').style.maxHeight = '0';
  });
  if (!isOpen) { item.classList.add('open'); aEl.style.maxHeight = aEl.scrollHeight + 'px'; }
}

// ══ DRAWER ══
function openDrawer(id) {
  document.getElementById(id).classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeDrawer(id) {
  document.getElementById(id).classList.remove('open');
  document.body.style.overflow = '';
}

// ══ PRODUCT MODAL ══
function openModal(id) {
  document.getElementById(id).classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeModal(id) {
  document.getElementById(id).classList.remove('open');
  document.body.style.overflow = '';
}
function adjustQty(id, delta) {
  const el = document.getElementById(id);
  const val = Math.max(1, parseInt(el.textContent) + delta);
  el.textContent = val;
}

// ══ SUBSCRIBE TOGGLE ══
function setSubMode(prodNum, mode) {
  if (typeof cbProducts === 'undefined') return;
  const isSub = mode === 'sub' && cbProducts[prodNum].sp;
  cbProducts[prodNum].sub = !!isSub;

  // Update all toggle buttons for this product (card + modal)
  document.querySelectorAll('.sub-opt[data-prod="' + prodNum + '"]').forEach(btn => {
    btn.classList.toggle('active', btn.textContent.trim().startsWith(isSub ? 'Subscribe' : 'One'));
  });
  // Also update modal toggles (no data-prod, matched by parent modal)
  const modal = document.getElementById('modal-p' + prodNum);
  if (modal) {
    modal.querySelectorAll('.sub-opt').forEach(btn => {
      btn.classList.toggle('active', btn.textContent.trim().startsWith(isSub ? 'Subscribe' : 'One'));
    });
  }

  // Toggle price wraps — card + modal
  ['subWrap' + prodNum, 'subWrapM' + prodNum].forEach(wid => {
    const wrap = document.getElementById(wid);
    if (wrap) wrap.classList.toggle('show-sub', !!isSub);
  });
}

// ══ ADD TO CART (Cart API) ══
function addToCart(prodNum) {
  if (typeof cbProducts === 'undefined') return;
  const p = cbProducts[prodNum];
  if (!p || !p.vid) { window.location.href = '/collections/all'; return; }

  const qtyEl = document.getElementById('q' + prodNum);
  const qty = qtyEl ? Math.max(1, parseInt(qtyEl.textContent)) : 1;

  const body = { items: [{ id: p.vid, quantity: qty }] };
  if (p.sub && p.sp) body.items[0].selling_plan = parseInt(p.sp);

  // Find the clicked button and show loading state
  const btns = document.querySelectorAll('.prod-btn, .pmodal-add');
  btns.forEach(b => { if (b._loading) return; });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  .then(r => {
    if (!r.ok) throw new Error('Cart error');
    return r.json();
  })
  .then(() => { window.location.href = '/cart'; })
  .catch(() => {
    // Fallback: go to product page
    const handles = { 1: 'pre-rolled-cones-200-pack', 2: 'chicone-wood-54mm', 3: 'caijian-color-200-count' };
    window.location.href = '/products/' + (handles[prodNum] || '');
  });
}

// ══ LIGHTBOX ══
function openLightbox(src) {
  const lb = document.getElementById('lightbox');
  document.getElementById('lightboxImg').src = src;
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeLightbox() {
  document.getElementById('lightbox').classList.remove('open');
  document.body.style.overflow = '';
}

// ── Mobile hamburger menu
function toggleMobileNav() {
  const navLinks = document.getElementById('navLinks');
  const burger = document.getElementById('navBurger');
  if (!navLinks || !burger) return;
  const isOpen = navLinks.classList.toggle('mobile-open');
  burger.classList.toggle('open', isOpen);
}

// Close mobile nav on link click
document.querySelectorAll('#navLinks a').forEach(link => {
  link.addEventListener('click', () => {
    const navLinks = document.getElementById('navLinks');
    const burger = document.getElementById('navBurger');
    if (navLinks) navLinks.classList.remove('mobile-open');
    if (burger) burger.classList.remove('open');
  });
});

// ── ESC key closes everything
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.drawer.open').forEach(d => d.classList.remove('open'));
  document.querySelectorAll('.pmodal.open').forEach(m => m.classList.remove('open'));
  const lb = document.getElementById('lightbox');
  if (lb) lb.classList.remove('open');
  // Close mobile nav
  const navLinks = document.getElementById('navLinks');
  const burger = document.getElementById('navBurger');
  if (navLinks) navLinks.classList.remove('mobile-open');
  if (burger) burger.classList.remove('open');
  document.body.style.overflow = '';
});
